import { periverseTheme } from '@peritasai/ui-shared';
import type { SxProps, Theme } from '@mui/material/styles';

const pageContainerSx = {
  px: { xs: '2.5rem', md: '1.5rem' },
  py: { xs: '2rem', md: '0.5rem' },
  display: 'flex',
  justifyContent: { xs: 'center', md: 'flex-start' },
  minHeight: 'calc(100vh - 80px)',
  position: 'relative',
} satisfies SxProps<Theme>;

const contentWrapSx = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: { xs: 'center', md: 'flex-start' },
  flex: 1,
  // A definite height (not minHeight) — descendants that use height:'100%'
  // only resolve against a definite ancestor height. overflowY handles
  // content taller than this box instead of letting the height shrink and
  // clip that chain.
  height: { xs: 'calc(100vh - 80px)', md: 'calc(100vh - 165px)' },
  minHeight: 0,
  overflowY: 'auto',
  marginTop: { xs: '-36px', md: '0px' },
} satisfies SxProps<Theme>;

export const pageContainerVariantSx = () =>
  ({
    ...pageContainerSx,
    paddingLeft: { xs: '0px', md: '1.5rem', lg: '1.5rem', xl: '1.5rem' },
    paddingRight: { xs: '0px', md: '1.5rem', lg: '1.5rem', xl: '1.5rem' },
    py: { xs: pageContainerSx.py.xs, md: '16px', lg: '16px' },
    minHeight: pageContainerSx.minHeight,
    justifyContent: pageContainerSx.justifyContent,
    mt: '0px',
    alignItems: { xs: 'center', md: 'flex-start' },
  } satisfies SxProps<Theme>);

export const contentWrapVariantSx = () =>
  ({
    ...contentWrapSx,
    px: '0px',
    marginTop: contentWrapSx.marginTop,
    height: contentWrapSx.height,
    minHeight: contentWrapSx.minHeight,
    justifyContent: contentWrapSx.justifyContent,
    alignItems: { xs: 'center', md: 'flex-start' },
  } satisfies SxProps<Theme>);

export const popupOverlaySx = {
  position: 'fixed',
  inset: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: { xs: '16px', md: '24px' },
  py: { xs: '24px', md: '32px' },
  backgroundColor: 'rgba(0, 0, 0, 0.20)',
  zIndex: periverseTheme.zIndex.modal,
} satisfies SxProps<Theme>;

export const cardSx = {
  width: { xs: '680px', md: '100%' },
  maxWidth: { xs: 680, md: '100%' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', md: 'stretch' },
  gap: { xs: '16px', md: '16px' },
  borderRadius: '24px',
  border: `1px solid ${periverseTheme.palette.divider}`,
  background: periverseTheme.palette.background.paper,
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.08)',
  padding: { xs: '40px 32px', md: '16px' },
} satisfies SxProps<Theme>;

export const loadingCardGridSx = {
  display: 'grid',
  gap: 2,
  width: '100%',
} satisfies SxProps<Theme>;
